// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Preact from "../bindings/Preact.js";
import * as Browser from "../bindings/Browser.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

let keypairKey = "tan_keypair";

let deviceIdKey = "tan_device_id";

let ticketPrefix = "tan_ticket_";

let isStorageAvailable = Browser.LocalStorage.isAvailable;

function isIncognito() {
  return !isStorageAvailable();
}

function storeKeypair(keypair) {
  if (!isStorageAvailable()) {
    return {
      TAG: "Error",
      _0: "localStorage is not available"
    };
  }
  let json = Stdlib_Option.getOr(JSON.stringify(keypair), "{}");
  window.localStorage.setItem(keypairKey, json);
  return {
    TAG: "Ok",
    _0: undefined
  };
}

function getKeypair() {
  if (!isStorageAvailable()) {
    return;
  }
  let stored = window.localStorage.getItem(keypairKey);
  if (stored == null) {
    return;
  }
  try {
    return JSON.parse(stored);
  } catch (exn) {
    return;
  }
}

function hasKeypair() {
  return Stdlib_Option.isSome(getKeypair());
}

function clearKeypair() {
  if (isStorageAvailable()) {
    window.localStorage.removeItem(keypairKey);
    return;
  }
}

function storeDeviceId(deviceId) {
  if (isStorageAvailable()) {
    window.localStorage.setItem(deviceIdKey, deviceId);
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else {
    return {
      TAG: "Error",
      _0: "localStorage is not available"
    };
  }
}

function getDeviceId() {
  if (isStorageAvailable()) {
    return Primitive_option.fromNullable(window.localStorage.getItem(deviceIdKey));
  }
}

function storeTicket(storeId, ticket) {
  if (!isStorageAvailable()) {
    return {
      TAG: "Error",
      _0: "localStorage is not available"
    };
  }
  let json = Stdlib_Option.getOr(JSON.stringify(ticket), "{}");
  window.localStorage.setItem(ticketPrefix + storeId, json);
  return {
    TAG: "Ok",
    _0: undefined
  };
}

function getTicket(storeId) {
  if (!isStorageAvailable()) {
    return;
  }
  let stored = window.localStorage.getItem(ticketPrefix + storeId);
  if (stored == null) {
    return;
  }
  try {
    return JSON.parse(stored);
  } catch (exn) {
    return;
  }
}

function hasTicket(storeId) {
  return Stdlib_Option.isSome(getTicket(storeId));
}

function clearTicket(storeId) {
  if (isStorageAvailable()) {
    window.localStorage.removeItem(ticketPrefix + storeId);
    return;
  }
}

function clearAll() {
  if (isStorageAvailable()) {
    window.localStorage.removeItem(keypairKey);
    window.localStorage.removeItem(deviceIdKey);
    return;
  }
}

function expose() {
  Preact.setWindowProperty("Storage", {
    isStorageAvailable: isStorageAvailable,
    isIncognito: isIncognito,
    storeKeypair: storeKeypair,
    getKeypair: getKeypair,
    hasKeypair: hasKeypair,
    clearKeypair: clearKeypair,
    storeDeviceId: storeDeviceId,
    getDeviceId: getDeviceId,
    storeTicket: storeTicket,
    getTicket: getTicket,
    hasTicket: hasTicket,
    clearTicket: clearTicket,
    clearAll: clearAll
  });
}

export {
  keypairKey,
  deviceIdKey,
  ticketPrefix,
  isStorageAvailable,
  isIncognito,
  storeKeypair,
  getKeypair,
  hasKeypair,
  clearKeypair,
  storeDeviceId,
  getDeviceId,
  storeTicket,
  getTicket,
  hasTicket,
  clearTicket,
  clearAll,
  expose,
}
/* No side effect */
